/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { FrontendQueryParameters, FrontendQueryString, QueryType, SqlQuery } from '@shared/types/queries';
import { outdent } from 'outdent';

export const DEFAULT_SQL_SETTINGS = {
  lazy: true,
  distributedJoins: false,
  selectedNodeConsistentId: null,
  defaultSchema: null,
  enforceJoinOrder: false,
};

export const DEFAULT_SCAN_QUERY_SETTINGS = {
  nodeConsistentId: null,
  partition: null,
  keyFilterRegex: null,
  valueFilterRegex: null,
};

export const DEFAULT_SQL_QUERY = (id: string): SqlQuery => ({
  query: outdent`CREATE TABLE Person(ID INTEGER PRIMARY KEY, NAME VARCHAR(100));
    INSERT INTO Person(ID, NAME) VALUES (1, 'Ed'), (2, 'Ann'), (3, 'Emma');
    SELECT * FROM Person;` as FrontendQueryString,
  name: 'Query',
  type: QueryType.SQL,
  id,
  parameters: {} as FrontendQueryParameters,
  ...DEFAULT_SQL_SETTINGS,
});

export const DEFAULT_SQL_QUERY_NAME = 'New SQL query';
export const DEFAULT_SCAN_QUERY_NAME = 'New scan query';
